import React, { Component } from 'react';
import Layout from '../layout';
import HardwareHero from '../assets/v2/png/HardwareHero.png';
import HardwareSectionOne from '../components/Esper/Hardware/HardwareSectionOne';
// import HardwareSectionTwo from '../components/Esper/Hardware/HardwareSectionTwo';
import HardwareSectionThree from '../components/Esper/Hardware/HardwareFeatures';
// import HardwareSectionThree from '../components/Esper/Hardware/HardwareSectionThree';
import { BottomBanner } from '../components/Esper/BottomBanner';
// import OurPartners from '../components/Esper/OurPartnersContactUs';
// import HardwareSectionFour from '../components/Esper/Hardware/HardwareSectionFour';
import HardwareSectionFive from '../components/Esper/Hardware/HardwareSectionFive';
import HardwareCarousel from '../components/Esper/Hardware/HardwareCarousel';
import messages from '../i18n/en';

export default class Hardware extends Component<any, any> {
  state = {
    wishArray: [],
  };

  updateWishList = () => {
    let storedList = localStorage.getItem('wishlist');
    storedList = storedList === null ? [] : JSON.parse(storedList);
    this.setState({
      wishArray: storedList,
    });
  };

  render() {
    return (
      <Layout
        messages={messages}
        ogImage={HardwareHero}
        title={'Solution for android kiosk mode | Esper Manage'}
        description={`Esper provides full stack android kiosk management solution that can be implemented across industries like retail, hospitality, finance and manage them remotely.`}
        keywords={`android kiosk mode, kiosk app android,remote management, mdm, mdm solutions`}
        className="first-page"
        location={this.props.location}
      >
        <HardwareSectionOne
          wishArray={this.state.wishArray}
          updateWishList={this.updateWishList}
        />
        {/* <HardwareSectionTwo /> */}
        <HardwareSectionThree />
        <HardwareSectionFive updateWishList={this.updateWishList} />
        {/* <HardwareSectionFour /> */}
        <HardwareCarousel />
        {/* <OurPartners
          companies={['lenovo', 'zebra', 'mediatek']}
          title={`You’re in good company, Our Partners `}
        /> */}
        <BottomBanner
          description={`Scale and deploy your Android devices
          on the field like never before!`}
          buttonText={`Start your free trial `}
          link="https://esper.io/signup"
        />
      </Layout>
    );
  }
}
